import { Suspense, useState } from "react"
import { BrowserRouter } from "react-router-dom"
import { Box, CssBaseline, ThemeProvider } from "@mui/material"
import i18next from "i18next"
import AppRouter from "./app-router"
import AppTheme from "./assets/theme/hsbc-theme"
import DialogContainer from "./components/dialog.container"
import LoadingContainer from "./components/loading.container"
import LOCALES from "./utils/constants/LOCALES"
import AppLogoutTimer from "./components/app-logout/app-logout-timer"

function App() {
  const [languageCheck, setLanguageCheck] = useState(false)
  const language = sessionStorage.getItem("language")
  if (!languageCheck) {
    if (language !== null && language !== undefined && language.length !== 0) {
      i18next.changeLanguage(language)
    } else {
      sessionStorage.setItem("language", LOCALES.ZH)
      i18next.changeLanguage(LOCALES.ZH)
    }
    setLanguageCheck(true)
  }

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ThemeProvider theme={AppTheme.hsbcTheme()}>
        <CssBaseline />
        <Box height="100vh">
          <Suspense fallback={<h1>Loading Apps...</h1>}>
            <AppRouter />
          </Suspense>
        </Box>
        <DialogContainer />
        <LoadingContainer />
        <AppLogoutTimer />
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
